import { getCanvasGradient } from './getCanvasGradient';

/**
 * Синяя линия
 */
export const getGradientFirstLine = (ctx: CanvasRenderingContext2D, chartHeight: number) =>
  getCanvasGradient(ctx, chartHeight, [
    { offset: 0.5, color: 'rgba(4, 104, 255, 0.24)' },
    { offset: 1, color: 'rgba(4, 104, 255, 0)' },
  ]);

/**
 * Красная линия
 */
export const getGradientSecondLine = (ctx: CanvasRenderingContext2D, chartHeight: number) =>
  getCanvasGradient(ctx, chartHeight, [
    { offset: 0.5, color: 'rgba(255, 31, 52, 0.24)' },
    { offset: 1, color: 'rgba(255, 31, 52, 0)' },
  ]);
